import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";

/**
 * Generated class for the FrequencyInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "oxygen-frequency-input",
  templateUrl: "oxygen-frequency-input.html",
})
export class OxygenFrequencyInputComponent implements OnInit, AfterViewInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  required: boolean;
  min: number;
  max: number;
  disabled: boolean;
  readonly: boolean = false;

  routeConfig: any;
  rateConfig: any;

  fieldTracker: object = {};

  constructor(public formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;

    if (this.config.rules) {
      this.required = this.config.rules.required;
      delete this.config.rules.required;

      this.min = this.config.rules.min;
      delete this.config.rules.min;

      this.max = this.config.rules.max;
      delete this.config.rules.max;
    }

    this.routeConfig = {
      id: "route",
      componentId: this.componentId + "Route",
      label: false,
      placeholder: "select",
      options: ["nasalCannula"],
      readonly: this.readonly,
    };

    this.rateConfig = {
      id: "rate",
      componentId: this.componentId + "Rate",
      label: false,
      placeholder: "select",
      options: ["2", "3", "4"],
      readonly: this.readonly,
    };

    this.group.addControl(this.id, this.formBuilder.control(null));

    // Inner form state
    this.innerGroup = this.formBuilder.group({});
    this.innerGroup.addControl("route", this.formBuilder.control(null));
    this.innerGroup.addControl("rate", this.formBuilder.control(null));

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      this.loadState(data);
    });

    this.innerGroup.valueChanges.subscribe((data) => {
      // Field tracker is used to make sure that we don't warn about fields until they have been modified
      // Should be replaced w/ inner group dirty state, but that was being finicky
      for (let key of Object.keys(data)) {
        if (
          !this.fieldTracker[key] &&
          data[key] !== undefined &&
          data[key] !== null
        ) {
          // console.log( "Setting field tracker: ", key, data[key] );
          this.fieldTracker[key] = true;
        }
      }

      this.group.controls[this.id].setValue(data);
      this.group.controls[this.id].setErrors(this.getErrors());
    });

    this.loadState(this.group.controls[this.id].value);
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  loadState(data) {
    let innerGroup = this.innerGroup;
    if (data === null) {
      innerGroup.setValue({
        route: null,
        rate: null,
      });
    } else if (data !== undefined && data !== innerGroup.value) {
      innerGroup.setValue(data);
    }

    let outerDisabled = this.group.controls[this.id].disabled;
    if (outerDisabled !== this.disabled) {
      this.disabled = outerDisabled;
      if (!this.disabled) {
        this.innerGroup.enable();
      } else {
        this.innerGroup.disable();
      }
    }
  }

  getErrors(): ValidationErrors {
    let errors = {};

    if (!this.disabled) {
      let innerControls = this.innerGroup.controls;
      for (let key of Object.keys(innerControls)) {
        let control = innerControls[key];
        let value = control.value;
      }
    }
    // console.log( "Determined frequency errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/oxygen-input/oxygen-frequency-input.ts